import { render, staticRenderFns } from "./OrderPrintItem.vue?vue&type=template&id=df537500&scoped=true&"
import script from "./OrderPrintItem.vue?vue&type=script&lang=js&"
export * from "./OrderPrintItem.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/order/OrderPrintItem/OrderPrintItemStyle.css?vue&type=style&index=0&id=df537500&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df537500",
  null
  
)

export default component.exports